import { testimonials } from '@/mocks/testimonials';

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Trusted by Users
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            What Users Say About Itaobuy Spreadsheet
          </h2>
          <p className="mt-4 text-foreground-600 text-base md:text-lg max-w-xl">
            Real experiences from real users who have transformed their workflow with this system.
          </p>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 md:gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="break-inside-avoid mb-5 md:mb-6 p-5 md:p-6 rounded-xl bg-background-50 border border-background-200"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.username}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                &ldquo;{t.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}